var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-pill-button",on:{"click":function($event){_vm.$emit('click')}}},[_c('div',{staticClass:"pc-pill-button__left"},[_vm._v("\n    "+_vm._s(_vm.leftText)+"\n  ")]),_c('div',{staticClass:"pc-pill-button__right"},[_vm._v("\n    "+_vm._s(_vm.rightText)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc9759c0","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/component/post-gift/component/pill-button/index.vue
// module id = 787
// module chunks = 0 1